require('./RASetGoalStep2.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
// @ commons
const { AmountInput } = require('commonsComponents/amountInput');
const { EditAlias } = require('commonsComponents/editAlias');
const { OKDatePicker } = require('commonsComponents/OKDatePicker');
const RAImageButton = require('components/RAComponents/commons/RAImageButton/RAImageButton');
// @ components
const RASetGoalStepHeader = require('components/RAComponents/RASetGoal/RASetGoalStepHeader/RASetGoalStepHeader');
// @ utilities
import { FormattedText, formatText, getLanguage } from 'core/i18n';

// @ constants
const {
    EURO_SYMBOL,
    FIRST_STEP,
    SECOND_STEP,
    RA_SET_GOAL_MAXIMUM_INVESTMENT_AMOUNT,
} = require('constants/RAConstants');

class RASetGoalStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            titleEditor: false,
        };
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleTitleFocus = this.handleTitleFocus.bind(this);
        this.handleTitleBlur = this.handleTitleBlur.bind(this);
        this.datePicker = React.createRef();
        this.editAlias = React.createRef();
    }

    componentDidUpdate(prevProps) {
        const { immCustomPlanByObjective, onUpdateAlias } = this.props;

        if (prevProps.immCustomPlanByObjective.get('objectiveType') != immCustomPlanByObjective.get('objectiveType')) {
            onUpdateAlias(this.editAlias);
        }
    }

    handleTitleChange(e) {
        this.props.onTitleChange(e);
    }

    handleTitleFocus() {
        this.setState({
            titleEditor: true,
        });
    }

    handleTitleBlur(e) {
        this.props.onTitleChange(e);
        this.setState({
            titleEditor: false,
        });
    }

    buildAmountSection() {
        const { immSteps, onInvestmentAmountChange, errorState, errorMsg, disabled } = this.props;
        const investmentAmount = immSteps.getIn([SECOND_STEP, 'investmentAmount']);
        return (
            <div className="ra-set-goal-step2__section-amount">
                <AmountInput
                    amount={investmentAmount}
                    callback={onInvestmentAmountChange}
                    error={errorState}
                    errorMsg={errorMsg}
                    hideFocusZero={true}
                    language={getLanguage()}
                    max={RA_SET_GOAL_MAXIMUM_INVESTMENT_AMOUNT}
                    name={name}
                    disabled={disabled}
                />
                <span className="ra-set-goal-step2__currency">{EURO_SYMBOL}</span>
            </div>
        );
    }

    buildCustomCalender() {
        const { onDateChange, immSteps, onChangePicker, disabled } = this.props;
        const investmentDate = immSteps.getIn([SECOND_STEP, 'investmentDate']);
        const dateLabel = formatText('raSetGoal-calenderText');
        const minDate = immSteps.getIn([SECOND_STEP, 'minDate']);
        const maxDate = immSteps.getIn([SECOND_STEP, 'maxDate']);
        return (
            <div className="ra-set-goal-step2__container--block-calendar">
                <div className="ra-set-goal-step2__container--block-calendar-label">{dateLabel}</div>
                <div className="date-picker__wrapper" onKeyUp={() => onChangePicker(this.datePicker)}>
                    <OKDatePicker
                        callback={onDateChange}
                        dateFormat={formatText('datePickerCustom-dateFormat')}
                        disabled={disabled}
                        startDate={minDate}
                        maxDate={maxDate}
                        minDate={minDate}
                        placeholder={formatText('datePickerCustom-placeholder')}
                        selectedDate={investmentDate}
                        newSelectedDate={investmentDate}
                        messageStandardErrorDate={formatText('raSetGoal-dateError')}
                        messageLessThanMinDateError={formatText('raSetGoal-minDateError')}
                        messageMoreThanMinDateError={formatText('raSetGoal-maxDateError')}
                        ref={this.datePicker}
                    />
                </div>
            </div>
        );
    }

    buildInvestmentContent() {
        const { immSteps, onTitleChange, extraClass } = this.props;
        const investmentTitle = immSteps.getIn([SECOND_STEP, 'investmentTitle']);
        const goals = immSteps.getIn([FIRST_STEP, 'goals']);
        const goalSelected = immSteps.getIn([FIRST_STEP, 'goalSelected']);
        const selectedGoal = goals.find(goal => {
            return goal.get('isSelected') === true;
        });
        const iconType = goalSelected && selectedGoal ? selectedGoal.get('id') : '';
        // add flag icon
        const extraContent = !goalSelected ? <i className="icons--icon-flag-objetive " /> : null;
        const extraClassForGoalWrapper = classNames(extraClass, {
            'ra-set-goal-step2__goal-icon--small': iconType == '',
        });

        return (
            <div className="ra-set-goal-step2__section-invest">
                <RAImageButton
                    extraClass="ra-set-goal-step2__section-invest--goal-icon"
                    extraClassForGoalWrapper={extraClassForGoalWrapper}
                    extraContent={extraContent}
                    iconType={iconType}
                    isSelected={true}
                    size="small"
                />
                <div className="profile-picture-editor__alias-edit ra-set-goal-step2__placeholder">
                    <EditAlias alias={investmentTitle} postAlias={onTitleChange} limit={21} ref={this.editAlias} />
                </div>
            </div>
        );
    }

    render() {
        const { disabled, isValid } = this.props;
        const amountSectionBlock = this.buildAmountSection();
        const calenderSectionBlock = this.buildCustomCalender();
        const iconInvestmentSectionBlock = this.buildInvestmentContent();
        const className = classNames('ra-set-goal-step2', {
            'ra-set-goal-step2--disabled': disabled,
        });

        return (
            <div className={className}>
                <RASetGoalStepHeader
                    title={formatText('raSetGoal-step2HeaderTitle')}
                    description={formatText('raSetGoal-step2HeaderDescription')}
                    active={isValid}
                />
                <div className="ra-set-goal-step2__container">
                    {iconInvestmentSectionBlock}
                    <hr />
                    <div className="row ra-set-goal-step2__container--block">
                        <div className="col-md-6">
                            <div className="ra-set-goal-step2__header-invest">
                                <FormattedText
                                    value="raSetGoal-goalAmountTitle"
                                    className="ra-set-goal-step2__text ra-set-goal-step2__text--active"
                                />
                            </div>
                            <div>{amountSectionBlock}</div>
                        </div>
                        <div className="col-md-6">{calenderSectionBlock}</div>
                    </div>
                </div>
            </div>
        );
    }
}

RASetGoalStep2.propTypes = {
    immSteps: PropTypes.object.isRequired,
    isValid: PropTypes.bool.isRequired,
    onDateChange: PropTypes.func.isRequired,
    onInvestmentAmountChange: PropTypes.func.isRequired,
    onTitleChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    errorState: PropTypes.bool,
    errorMsg: PropTypes.string,
    extraClass: PropTypes.string,
};

module.exports = RASetGoalStep2;
